import React from 'react';
import { Avatar, Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { brand } from '../../theme';

export default function UserTalentElement({ userTalent, userLogged, onContact }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const fullName = [userTalent.name, userTalent.surname].filter(Boolean).join(' ') || '—';
    const skills = String(userTalent.skills || '').split(',').map((s) => s.trim()).filter(Boolean);
    const isMe = userLogged && String(userLogged.userId) === String(userTalent.userId);

    const handleSend = () => {
        onContact && onContact();
        navigate("/talent-user-direct-contact", { state: { userTalent } });
    };

    return (
        <Paper variant="outlined" sx={{ p: 2, borderRadius: 4, borderColor: 'divider' }}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'flex-start' }}>
                <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0, flex: 1 }}>
                    <Avatar sx={{ width: 44, height: 44, fontWeight: 800, background: brand.gradient }}>{fullName.charAt(0).toUpperCase()}</Avatar>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography sx={{ fontWeight: 800 }} noWrap>{fullName}{isMe ? ` (${t('talent.you')})` : ''}</Typography>
                        {userTalent.sector && <Typography variant="body2" color="primary" sx={{ fontWeight: 700 }} noWrap>{userTalent.sector}</Typography>}
                    </Box>
                </Stack>
                {!isMe && (
                    <Button variant="contained" size="small" endIcon={<SendRoundedIcon />} onClick={handleSend} sx={{ alignSelf: { xs: 'stretch', sm: 'center' }, flexShrink: 0 }}>
                        {t('talent.contactTooltip')}
                    </Button>
                )}
            </Stack>
            {userTalent.summary && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5, display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                    {userTalent.summary}
                </Typography>
            )}
            {skills.length > 0 && (
                <Stack direction="row" sx={{ mt: 1.5, gap: 0.75, flexWrap: 'wrap' }}>
                    {skills.slice(0, 8).map((skill) => <Chip key={skill} label={skill} size="small" sx={{ backgroundColor: '#EEF2FF', color: 'primary.dark' }} />)}
                    {skills.length > 8 && <Chip label={`+${skills.length - 8}`} size="small" />}
                </Stack>
            )}
        </Paper>
    );
}
